import * as React from 'react';
import { createCtx } from '../utils/createCtx';

export interface SearchComponentContextType {
  searchBarComponent: React.ReactNode;
  searchBarType?: 'omnisearch' | 'ubik';
}

export const [useSearchComponentContext, SearchComponentContext] =
  createCtx<SearchComponentContextType>();

export const SearchComponentProvider: React.FC<{
  children: React.ReactNode;
  searchBarComponent: React.ReactNode;
  searchBarType?: 'omnisearch' | 'ubik';
}> = (props) => {
  return (
    <SearchComponentContext
      value={{
        searchBarComponent: props.searchBarComponent,
        searchBarType: props.searchBarType,
      }}
    >
      {props.children}
    </SearchComponentContext>
  );
};
